import { z } from "zod";

export const UserSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string(),
  image: z.string().nullish(),
  is_active: z.boolean(),
  is_superuser: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const AuthenticationSchema = z.object({
  access_token: z.string(),
  refresh_token: z.string(),
});

export type User = z.infer<typeof UserSchema>;
export type Authentication = z.infer<typeof AuthenticationSchema>;
